import React from 'react';
import { Typography } from 'antd';
import { useTheme } from '../../contexts/ThemeContext';
import Modal from './Modal';

const { Title, Text } = Typography;

/**
 * Custom Modal Component - Versão simplificada usando o Modal base
 * @param {string} title - Título do modal
 * @param {string|React.Component} content - Conteúdo ou texto principal do modal
 * @param {boolean} open - Controla a visibilidade do modal
 * @param {function} onConfirm - Função executada ao clicar no botão de confirmação
 * @param {string} confirmText - Texto exibido no botão de confirmação
 * @param {function} onCancel - Função executada ao clicar no botão de fechar ou cancelar
 * @param {string} cancelText - Texto do botão de cancelar
 * @param {boolean} loading - Estado de loading
 * @param {string} variant - Variante do modal (default, form, confirmation, info, alert)
 */
const CustomModal = ({ 
  title, 
  content, 
  open, 
  onConfirm, 
  confirmText = 'Confirmar',
  onCancel,
  cancelText = 'Cancelar',
  loading = false,
  variant = 'default',
  showConfirmButton = true,
  showCancelButton = true,
  ...props 
}) => {
  const { theme } = useTheme();

  return (
    <Modal
      title={
        <Title level={4} style={{ margin: 0, color: theme.textSecondary }}>
          {title}
        </Title>
      }
      open={open}
       onCancel={onCancel}
      onOk={onConfirm}
      okText={confirmText}
      cancelText={cancelText}
      loading={loading}
      variant={variant}
      showOkButton={showConfirmButton}
      showCancelButton={showCancelButton}
      {...props}
    >
      <div style={{ padding: '8px 0' }}>
        {typeof content === 'string' ? (
          <Text style={{ fontSize: '15px', lineHeight: '1.6', color: theme.textSecondary }}>
            {content}
          </Text>
        ) : (
          content
        )}
      </div>
    </Modal>
  );
};

export default CustomModal;